import { cn } from '@/lib/cn';
import { useAuiFillPath } from '../AuiFillPathContext';
import type { AuiRendererProps } from '../registry';

export function AuiColumn({ node, children }: AuiRendererProps) {
  const props = node.component.props ?? {};
  const rawGap = props.gap;
  const gap = typeof rawGap === 'number' ? rawGap : undefined;
  const align = (props.align as string) ?? 'stretch';
  const isOnFillPath = useAuiFillPath(node.id);

  const alignMap: Record<string, string> = {
    start: 'flex-start',
    center: 'center',
    end: 'flex-end',
    stretch: 'stretch',
  };

  return (
    <div
      // Only claim flex height when this column sits on the fill path computed
      // by AuiSurface (see AuiFillPathContext). Outside that path the column
      // is content-sized so nested layouts stay predictable.
      className={cn('flex flex-col', isOnFillPath && 'flex-1 min-h-0')}
      style={{
        gap: `${(gap ?? 4) * 0.25}rem`,
        alignItems: alignMap[align] ?? 'stretch',
      }}
      data-testid="aui-column"
    >
      {children}
    </div>
  );
}
